import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import api from '../utils/api'; 
import '../style.css'
import CircularProgress from '@mui/material/CircularProgress';

const TopBoreholeChart = ({range, selectedRegions, selectedDistricts, title, monthYear}) => {
    const [loading, setLoading] = useState(true);

    const [topBoreholeChartData, setTopBoreholeChartData] = useState({
        series: [{
              data: []
            }],
        options: {
            chart: {
                type: 'bar',
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    }
                }
            },
            // labels: [],
            states: {
                active: {
                    allowMultipleDataPointsSelection: true,
                    filter: {
                        type: 'light'
                    }
                }
            },
            legend: {
                show: false
              },
            title: {
                text: ''
            },
            plotOptions: {
                bar: {
                  distributed: true,
                  horizontal: true,
                  barHeight: '75%',
                  dataLabels: {
                    position: 'bottom'
                  }
                }
            },
            dataLabels: {
                enabled: true,
                textAnchor: 'start',
                style: {
                  colors: ['#000000ff'],
                  fontWeight: 300,
                },
                formatter: function (val, opt) {
                    // console.log(opt.w.globals.labels[opt.dataPointIndex], opt.w.globals.labels, opt.dataPointIndex);
                    return opt.w.globals.labels[opt.dataPointIndex]
                    // if (val >= 1_000_000) return (val / 1_000_000).toFixed(1) + "M";
                    // if (val >= 1_000) return (val / 1_000).toFixed(1) + "K";
                    // return val;
                },
                offsetX: 0,
                dropShadow: {
                  enabled: true
                }
            },
            tooltip: {
               x: { show: false },
                y: {
                    formatter: (val) => Number(val).toLocaleString('en-US'),
                    title: {
                    formatter: (val, opts) => opts.w.globals.labels[opts.dataPointIndex]
                    }
                }
            },
            yaxis: {
                labels: {
                  show: false
                }
              },
            xaxis: {
                labels: {
                    formatter: (val) => {
                    // val can be string or number
                    const n = typeof val === 'string' ? parseFloat(val) : val;
                    return Number.isFinite(n) ? n.toLocaleString('en-US') : val;
                    }
                }
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 400
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        }
    });
    
    useEffect(() => {
        if (range[0] != null) {
            setLoading(true);
            const controller = new AbortController();
            let start_date = new Date(range[0]).toISOString().slice(0, 10);
            let end_date = new Date(range[1]).toISOString().slice(0, 10);
            const monthsParam = monthYear.join(','); 
            let url = "topborehole-truck/";
            if (title==='Top Borehole By Water Trucking'){
                url = "topborehole-truck/";
            } else if (title==='Top Borehole By Livestock Served'){
                url = "topborehole-livestock/";
            } else if (title==='Top Borehole By Household Served'){
                url = "topborehole-household/";
            }
            api.get(url, {
                params: {
                    start: start_date,
                    end: end_date,
                    region:JSON.stringify(selectedRegions),
                    district:JSON.stringify(selectedDistricts),
                    months : monthsParam
                },
                signal: controller.signal
            }).then(res => {
                const data = JSON.parse(res.data);  // or res.data directly if already JSON
                setTopBoreholeChartData(prev => ({
                    series: [{
                        data: data.map(d => ({
                            x: d.borehole_name + ' - ' + d.district + ' - ' + d.region,
                            y: d.cnt,
                        }))
                    }],  
                    options: {
                        ...prev.options,
                        title : { text : title}, 
                    }
                    
                }));
            }).catch((err) => {
                console.error('Failed to fetch reports:', err);
            })
            .finally(() => setLoading(false));
            return () => {
                controller.abort();
            };
        }
    }, [monthYear, selectedRegions, selectedDistricts]);


    return (
        <>
        <div id='wrap1'> 
            <div id="chart-malfunction" style={{ minHeight: 352, width: '100%' }}>
                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <ReactApexChart key={JSON.stringify(topBoreholeChartData.series)} options={topBoreholeChartData.options} series={topBoreholeChartData.series} type="bar" width={'100%'} height={310} />
                )}
            </div>
        </div>
        </>
    );
};

export default TopBoreholeChart;